import { HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

const getters = {
  [getterTypes.GET_CHANNEL]: state => state.channel,
  [getterTypes.GET_CHANNELS]: state => state.channels,
};

const actions = {
  async [actionTypes.DO_GET_CHANNELS]({ commit }, params) {
    const { data } = await HTTP.get('/channels', { params });
    commit(mutationTypes.SET_CHANNELS, data.data.channels);
    return data;
  },
};

const mutations = {
  [mutationTypes.SET_CHANNEL](state, channel) {
    state.channel = channel;
  },
  [mutationTypes.SET_CHANNELS](state, channels) {
    state.channels = channels;
  },
};

export default {
  state: {
    channel: {},
    channels: [],
  },
  getters,
  actions,
  mutations,
};
